import styled from 'styled-components'
import { t } from '@/i18n'

interface ShowTotalProps {
  children: string | number
}
export const ShowTotal = (props: ShowTotalProps) => (
  <div>
    {t('共')}
    <Children>{props.children}</Children>
    {t('条')}
  </div>
)

const Children = styled.span`
  color: #4238c9;
`
